import { Avatar as LobbyAvatar } from "../editor/avatar.js"
class Skin {
  constructor() {
    this.init()
  }
  init() {
    const skin = new LobbyAvatar()
    skin.initSettings()
  }
}
new Skin()
